'use client';
import { Popover } from './popover.js';
import { PopoverTrigger } from './popover-trigger.js';
import { PopoverTriggerContext } from './popover-trigger-context.js';

/**
 * Popover component, used to display content in a popover over an element.
 *
 * @example
 * <Popover.TriggerContext>
 *   <Popover.Trigger>Open Popover</Popover.Trigger>
 *   <Popover>
 *     Content
 *   </Popover>
 * </Popover.TriggerContext>
 */
const PopoverComponent = Object.assign(Popover, {
    TriggerContext: PopoverTriggerContext,
    Trigger: PopoverTrigger,
});
PopoverComponent.TriggerContext.displayName = 'Popover.TriggerContext';
PopoverComponent.Trigger.displayName = 'Popover.Trigger';

export { PopoverComponent as Popover, PopoverTrigger, PopoverTriggerContext };
